<div class="bg-gray-light p-3 summary">
  <div>
    <span class="font-weight-bold">{{
      route.stopsState[0] | address : "summary"
    }}</span>
    to
    <span class="font-weight-bold">{{
      route.stopsState[route.stopsState.length - 1] | address : "summary"
    }}</span>
  </div>
  <div>
    <!-- TODO clean up and add options once the route profile work is done -->
    <span class="font-weight-bold">Stops: </span
    >{{ route.stopsState.length - 2 }}
    <span class="font-weight-bold">Total Cost: </span
    >{{
      route.mileageReport?.ReportLines[
        route.mileageReport.ReportLines.length - 1
      ].TCostMile | displayCurrency : displayCurrency
    }}
  </div>
  <div class="summary" *ngIf="vehicle.weight">
    <span class="font-weight-bold">Weight: </span
    ><span>{{ this.vehicle.weight }}</span>
    <span class="ml-1 mr-1">|</span>
    <span class="font-weight-bold mr-1">Height: </span
    ><span>{{ this.vehicle.height }}</span
    ><span class="ml-1 mr-1">|</span>
    <span class="font-weight-bold">Length: </span
    ><span>{{ this.vehicle.length }}</span
    ><span class="ml-1 mr-1">|</span>
    <span class="font-weight-bold">Width: </span
    ><span>{{ this.vehicle.width }}</span
    ><span class="ml-1 mr-1">|</span>
    <span class="font-weight-bold">Axles: </span
    ><span>{{ this.vehicle.axles }}</span>
  </div>
  <div class="summary">
    <span class="font-weight-bold">Details: </span>{{ profileDetails }}
  </div>
</div>
